import styled from 'styled-components'
import type { Props } from './DemographicsCharts'
import * as _ from 'styles/helpers'

const StyledDemographicsCharts = styled.div<Partial<Props>>`
	> div {
		margin-bottom: ${_.rem(18)};
	}

	.key-value {
		.key,
		.value {
			display: block;
		}
		.key {
			font-size: ${_.rem(12)};
			font-weight: 600;
		}
		.value {
		}
	}

	.DemographicsCharts {
		// .DemographicsCharts__header
		&__header {
			margin-bottom: ${_.rem(8)};

			.h2 {
				display: flex;
				grid-gap: ${_.rem(24)};
			}
		}

		// .DemographicsCharts__grid
		&__grid {
			display: flex;
			grid-gap: ${_.rem(24)};

			> div {
				flex: 1;
			}

			@media ${_.MQ.before_nav} {
				flex-direction: column;
				grid-gap: ${_.rem(16)};

				> div {
					flex: none;
					width: 100%;
				}
			}
		}

		// .DemographicsCharts__paired-grid (mobile: bar + pie stacked together)
		&__paired-grid {
			display: none;

			@media ${_.MQ.before_nav} {
				display: flex;
				flex-direction: column;
				gap: ${_.rem(16)};
				padding: 0 ${_.rem(12)};
			}
		}

		// .DemographicsCharts__pair (one bar chart + one pie chart)
		&__pair {
			display: flex;
			flex-direction: column;
			gap: ${_.rem(12)};

			> div {
				width: 100%;
			}
		}

		// Hide regular grids on mobile when paired layout is used
		&__desktop-only {
			@media ${_.MQ.before_nav} {
				display: none;
			}
		}

		// .DemographicsCharts__chart
		&__chart {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-bottom: ${_.rem(8)};
			/* height: ${_.rem(320)}; */
		}

		// .DemographicsCharts__toggle-button
		&__toggle-button {
			${_.MIXINS.vhc}
			margin-bottom: ${_.rem(28)};
		}
	}
`

export default StyledDemographicsCharts
